module.exports = __webpack_public_path__ + "img/book.77d5a6dd.jpg";